import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import { styled } from "@mui/system";
import { useTranslation } from "react-i18next";
import api from "../../globals/axios";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../Alert";
import PasswordVisibility from "../PasswordVisibility"

const CenteredDialog = styled(Dialog)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const ButtonContainer = styled(DialogActions)({
  justifyContent: "center",
});

const DeleteAccountDialog = ({ open, onClose }) => {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const { showAlert } = useAlert();

  const handleDelete = async () => {
    try {
      setDisabled(true);
      const response = await api.delete("/auth/delete-account/", {
        data: { password },
      });
      if (response.status === 200) {
        setMessage("Account Deleted Successfully");
        showAlert("success", "Account Deleted Successfully");
        setTimeout(() => {
          navigate("/login"); 
        }, 1000);
      }
    } catch (err) {
      setDisabled(false);
      const errorMessage = err.response?.data?.message || "An error occurred. Please try again.";
      showAlert("error", errorMessage);
      setMessage(errorMessage);
    }
  };

  return (
    <CenteredDialog open={open} onClose={onClose}>
      <DialogContent>
        <div
          style={{
            color: "red",
            marginTop: "8px",
            textAlign: "center",
            marginBottom: "15px",
          }}
        >
          {t("Warning: This action is irreversible!")}
        </div>
        <TextField
          margin="dense"
          label="Password"
          type={showPassword ? "text" : "password"}
          fullWidth
          value={password}
          InputProps={{
              endAdornment: (
                <PasswordVisibility
                  showPassword={showPassword}
                  setShowPassword={setShowPassword}
                />
              ),
            }}
          onChange={(e) => setPassword(e.target.value)}
        />
        {message && (
          <div style={{ color: "red", marginTop: "8px", textAlign: "center" }}>
            {message}
          </div>
        )}
      </DialogContent>
      <ButtonContainer>
        <Button
          sx={{ bgcolor: "#4CAF50", color: "white", width: "130px" }}
          onClick={onClose}
        >
          {t("Cancel")}
        </Button>
        <Button
          sx={{ backgroundColor: "#CF5C5C", color: "white", width: "130px" }}
          onClick={handleDelete}
          color="error"
          disabled={disabled}
        >
          {t("Delete")}
        </Button>
      </ButtonContainer>
    </CenteredDialog>
  );
};

export default DeleteAccountDialog;
